module.exports = __webpack_public_path__ + "media/src/img/howhelp-1-4e9d9fc667dfaf5627b64f9c31156e24.png";